export const Default = 0
export const Admin = 1
export const Courier = 2
export const Moderator = 3
export const Monitoring = 4
export const Revizor = 5
